import { Preferences } from "@capacitor/preferences";

export const setUser = async (user) => {
  await Preferences.set({
    key: "user",
    value: JSON.stringify(user),
  });
};

export const getUser = () => {
  return Preferences.get({ key: "user" }).then(({ value }) => {
    return value ? JSON.parse(value) : null;
  });
};

export const removeCookie = async (key) => {
  await Preferences.remove({ key: key });
};


export const getUniqueDataById = (prevData, newData, idKey = "id") => {
  const combinedData = [...prevData, ...newData];
  const uniqueDataMap = new Map();

  combinedData.forEach((item) => {
    uniqueDataMap.set(item[idKey], item);
  });

  return Array.from(uniqueDataMap.values());
};
